import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


export const toggleUserStatus = createAsyncThunk(
  "user/toggleUserStatus",
  async ({ id, token }, { rejectWithValue }) => {
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_BASE_URL}/users/status/${id}`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(response)

      if (response.data.status) {
        console.log(response.data.status)
        return { id, response: response.data };
      } else {
        return rejectWithValue(response.data);
      }
    } catch (error) {
      toast(error.response.data.message)
      return rejectWithValue(error.response?.data || "Error toggling user status");
    }
  }
);


export const deleteUser = createAsyncThunk(
  "link/deleteUser",
  async ({ id, token }, { rejectWithValue }) => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_BASE_URL}/users?id=${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );


      if (response.status === 200) {
        return id;
      } else {
        return rejectWithValue(response.data);
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Error deleting user"
      );
    }
  }
);

export const EditUser = createAsyncThunk(
  "user/EditUser",
  async ({ token, name, userId,bio }, { rejectWithValue }) => {
    // console.log(bio)
    try {

      const response = await axios.patch(
        `${process.env.REACT_APP_BASE_URL}/users/${userId}`,
        { name,bio },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "An error occurred while Editing the user.");
    }
  }
);

export const addUser = createAsyncThunk(
  "user/addUser",
  async ({ token, formData }, { rejectWithValue }) => {
    try {
      // console.log(formData)
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/users`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.status) {
        return response.data;
      } else {
        return rejectWithValue(response.data?.message || "Failed to add user.");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "An unexpected error occurred. Please try again later."
      );
    }
  }
);

export const getUsers = createAsyncThunk(
  "user/getUser",
  async ({ token, offset = 1, limit = 10 }, { rejectWithValue }) => {
    try {

      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/users`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: { offset, limit },
      });
      if (response.data.status) {
        // console.log(response.data)
        return response.data.response;

      }

      // return response.data.response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || "Something went wrong"
      );
    }
  }
);


export const signupUser = createAsyncThunk(
  "user/signupUser",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/auth/signup`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(userData),
      });
      if (!response.ok) throw new Error("Signup failed");
      return response.json();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const userSlice = createSlice({
  name: "user",
  initialState: {
    Users: [],
    isLoading: false,
    data: null,
    isError: false,
    errorMessage: "",
  },
  reducers: {
    resetUsers: (state) => {
      state.Users = []
      state.isLoading = false
      state.data = null
      state.isError = false
      state.errorMessage = ""
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(signupUser.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = "";
      })
      .addCase(signupUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.isError = false;
      })
      .addCase(signupUser.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload || "Something went wrong";
      })
      .addCase(getUsers.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = "";
      })
      .addCase(getUsers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.Users = action.payload || [];
        // localStorage.setItem("No-Users", JSON.stringify(state.Users));
        // toast.success("Users fetched successfully! 📚");
      })
      .addCase(getUsers.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
        // toast.error(action.payload || "Failed to fetch users");
      })
      .addCase(EditUser.fulfilled, (state, action) => {
        state.isLoading = false;
        toast.success("User updated successfully! ✏️");
      })
      .addCase(EditUser.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
        toast.error(action.payload || "Failed to edit user");
      })
      .addCase(addUser.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addUser.fulfilled, (state, action) => {
        state.isLoading = false;
        toast.success("User added successfully! ");
      })
      .addCase(addUser.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
        toast.error(action.payload || "Failed to add user");
      })
      .addCase(deleteUser.fulfilled, (state, action) => {
        state.Users = state.Users.filter(
          (user) => user.userId !== action.payload
        );
        // localStorage.setItem("No-Users", JSON.stringify(state.Users));
        toast.success("User deleted successfully! 🗑️");
      })
      .addCase(deleteUser.rejected, (state, action) => {
        console.log(action.payload)
        toast.error(action.payload.message || "Error deleting user");
      })
      .addCase(toggleUserStatus.fulfilled, (state, action) => {
        state.isLoading = false;
        const { id, response } = action.payload;


        // Update the status of the user in the Users array
        state.Users = state.Users.map((user) =>
          user.userId === id ? { ...user, status: user.status === 1 ? 0 : 1 } : user
        );

        // Update local storage after toggling
        // localStorage.setItem("No-Users", JSON.stringify(state.Users));
        // toast.success(`User status updated to ${response.status ? "Active" : "Inactive"}! 🔄`);
      })
      .addCase(toggleUserStatus.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
        // toast.error(action.payload || "Failed to toggle user status");
      })
  },
});

export const { resetUsers } = userSlice.actions

export default userSlice.reducer;